import React from 'react';
import { observer } from 'mobx-react';
import { Item, Content, Info, Label, Editor } from '../Item';
import Icon from '../../../../components/Icon';
var Breaker = function Breaker(_ref) {
  var question = _ref.question,
    answer = _ref.answer,
    onChange = _ref.onChange,
    onUpdate = _ref.onUpdate,
    checkout = _ref.checkout;
  return /*#__PURE__*/React.createElement(Item, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Content, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Info, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Label, {
    checkout: checkout
  }, question.question)), /*#__PURE__*/React.createElement(Editor, {
    checkout: checkout
  }, /*#__PURE__*/React.createElement(Icon, {
    material: true,
    name: "warning",
    title: "This is a breaker, and so the responses are not valid."
  }))));
};
export default observer(Breaker);
//# sourceMappingURL=index.js.map
